module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/food-beb23a8ec9807f14e1abf182b63bd109.svg";